<template>
	<div>
		<div class="content-left-right-split select-border">
			<Select filterable v-model="sc_value" :size="sc_size" :multiple="sc_multiple" @on-change="handleChange">
				<Option v-for="item in sc_optionList" :value="item.value" :key="item.key">{{ item.key }}
				</Option>
			</Select>
			<Button shape="circle" icon="ios-settings-outline" type="primary" title="操作种类" :size='sc_size'
				@click="sc_modalDisPlay=true;">
				设置
			</Button>
		</div>
		<Modal v-model="sc_modalDisPlay" draggable sticky scrollable>
			<p slot="header" style="text-align:left">
				<Icon type="ios-create-outline" size='18' />
				<span> 添加种类</span>
			</p>
			<div class="modal-content">
				<table style="width:100%;">
					<tr>
						<td style="width:100%;" colspan="2">
							<Input v-model="sc_formItem.key" placeholder="请输入选项"
								@keyup.enter.native="sc_addDictionary()" />
						</td>
					</tr>
					<tr>
						<td class="tab-hander" style="width: 180px;">选项</td>
						<td class="tab-hander" style="text-align:center;">操作</td>
					</tr>
					<tr v-for="item in sc_optionList">
						<td>&nbsp;&nbsp;{{item.key}}</td>
						<td style="text-align:center;">
							<Icon type="md-trash" size='20' class="deleOption"
								@click.stop="sc_deleOption(item.id)" />
						</td>
					</tr>
				</table>
			</div>
			<div slot="footer">
				<button class="jxyd-button jxyd-primary" @click="sc_cancel()">关闭</button>
				<button class="jxyd-button" @click="sc_addDictionary()">保存</button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import request from '@/utils/request'

	export default {
		name: 'SelectConfig',
		props: ['sc_data', 'sc_type', 'sc_multiple', 'sc_size'],
		data() {
			return {
				sc_optionList: [],
				sc_value: [],
				sc_modalDisPlay: false,
				sc_formItem: {
					id: 0,
					key: '',
					value: '',
					pid: 0,
					pcode: '',
					creator: parseInt(localStorage.getItem("userId"))
				}
			}
		},

		methods: {
			handleChange(value) {
				// 获取处理后的值（字符串格式）
				let processedValue;
				if (this.sc_multiple && Array.isArray(value)) {
					// 多选：返回逗号分隔的字符串
					processedValue = value.join(',');
				} else {
					// 单选：直接返回值
					processedValue = value;
				}
				
				// 触发 .sync 双向绑定
				this.$emit('update:sc_data', processedValue);
				
				// 触发自定义 change 事件
				// 传递两个参数：1.处理后的字符串值 2.原始值（数组或字符串）
				this.$emit('change', processedValue, value);
			},
			
			sc_initOptionList() {
				let component = this;
				//获取供应商品类数据字典
				request.get('/api/DataDictionary/GetDataDictionaryList', {
					params: {
						code: this.sc_type
					}
				}).then(function(response) {
					if (response.state == 0) {
						component.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取字典数据失败：" + response.errorMsg
						});
						return;
					}

					component.sc_optionList = response.data;
				}).catch(function(error) {})
			},
			sc_addDictionary() {
				if (!this.sc_formItem.key) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '选项不可为空!'
					});
					return;
				}

				if (this.sc_formItem.key.length > 20) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '输入内容不得大于20个字!'
					});
					return;
				}
				this.sc_formItem.value = this.sc_formItem.key;
				this.sc_formItem.pcode = this.sc_type;
				let component = this;
				request.post('/api/DataDictionary/AddDataDictionary', this.sc_formItem).then(function(response) {
					if (response.state == 0) {
						component.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}

					component.sc_initOptionList();
					component.sc_formItem.key = '';
					component.sc_formItem.value = '';
					component.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '保存成功!'
					});

				}).catch(function(error) {})
			},
			getValue() {
				if (this.sc_multiple && typeof(this.sc_value) == "object") {
					return this.sc_value.join(',');
				} else {
					if (this.sc_value) {
						return this.sc_value + '';
					}
					return '';
				}
			},
			sc_deleOption(id) {
				var component = this;
				request.post('/api/DataDictionary/DeleDataDictionary', [id]).then(function(response) {
					if (response.state == 0) {
						component.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					component.sc_initOptionList();
					component.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '删除成功!'
					});
				}).catch(function(error) {})
			},
			sc_cancel() {
				this.sc_modalDisPlay = false;
			},
		},
		watch: {
			sc_data(val) {
				// 当父组件传入的值改变时，同步更新内部sc_value
				if (val !== null && val !== undefined) {
					if (val.indexOf(',') > -1) {
						this.sc_value = val.split(',');
					} else {
						this.sc_value = val;
					}
				} else {
					// 处理空值情况
					if (this.sc_multiple) {
						this.sc_value = [];
					} else {
						this.sc_value = '';
					}
				}
			}
		},
		created: function() {
			this.sc_initOptionList();
			
			// 初始化sc_value值
			if (this.sc_data !== null && this.sc_data !== undefined && this.sc_data !== '') {
				if (this.sc_data.indexOf(',') > -1) {
					this.sc_value = this.sc_data.split(',');
				} else {
					this.sc_value = this.sc_data;
				}
			} else {
				// 如果是多选，初始化空数组
				if (this.sc_multiple) {
					this.sc_value = [];
				}
			}
		}
	}
</script>

<style scoped>
	.ivu-select-multiple .ivu-select-item-selected:after {
		content: '' !important;
	}

	.deleOption {
		cursor: pointer;
	}

	.deleOption:hover {
		transform: scale(1.1);
	}

	.deleOption:focus {
		box-shadow: 0px 0px 1px 1px #808080;
	}

	.tab-hander {
		background: #f7f7f7;
		color: #5c6b77;
		font-weight: 600;
		font-size: 15px;
	}

	.modal-content {
		width: 100%;
		padding: 5px;
		background-color: #fff;
		border-radius: 5px;
		height: 300px;
		overflow: auto;
	}
	
	.select-border{
		border: 1px solid #dcdee2;
		background-color: #fff;
		line-height: 1.5;
		padding: 4px 7px;
		font-size: 14px;
		width: 100%;
		height: 32px;
		border-radius: 4px;
		transition: border .2s ease-in-out,background .2s ease-in-out,box-shadow .2s ease-in-out;
	}
	
	/deep/ .ivu-select-selection{
		border: none !important;
	}
	
	/deep/ .ivu-btn-primary{
		color: #fff;
		background-color: #ff6a7f !important;
		border-color: #ff6a7f !important;
	}
	
	/deep/ .ivu-btn-primary:hover {
		color: #fff;
		background-color: #ff6a7f !important;
		border-color: #ff6a7f !important;
	}
</style>